// @ts-nocheck - Class component types incompatible with React 18 + TS5
import { truncateTextInMiddle } from 'helpers/textHelper';
import React from 'react';
import ReactLinkify from 'react-linkify';

interface OwnProps {
  text: string;
}

const CustomDataText = (props: OwnProps) => {
  const { text } = props;
  return (
    <div className="CustomDataText">
      <ReactLinkify
        componentDecorator={(decoratedHref, decoratedText, key) => {
          const url = new URL(decoratedHref);

          if (url.protocol === 'mailto:') {
            return (
              <a target="blank" href={decoratedHref} key={key}>
                {decoratedText}
              </a>
            );
          }

          const mergedPathWithQuery = url.pathname + url.search;
          const truncate = truncateTextInMiddle(mergedPathWithQuery, 15);

          return (
            <a target="blank" href={decoratedHref} key={key}>
              {`${url.hostname}${truncate}`}
            </a>
          );
        }}
      >
        {text}
      </ReactLinkify>
    </div>
  );
};

export default CustomDataText;
